module.exports = __webpack_public_path__ + "img/homeimg03.13e3decb.png";